
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import EchangeModel from '@/models/EchangeModel'
import convertDateDirective from '@/directives/convertDateDirective'

@Component({
  components: {
    BaseFormContainer,
    SelectRef,
    SelectConseiller
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {}
  }
})
export default class EchangeForm extends BaseForm {
  @Prop(Array) contacts!: object[]
  model = EchangeModel

  getLabel({NOM, PRENOM, EMAIL, TELEPHONE1, TELEPHONE2}) {
    if (NOM && PRENOM) return `${PRENOM} ${NOM}`
    if (NOM) return `${NOM}`
    if (PRENOM) return `${PRENOM}`
    if (EMAIL) return `${EMAIL}`
    if (TELEPHONE1) return `${TELEPHONE1}`
    if (TELEPHONE2) return `${TELEPHONE2}`
  }
}
